var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.974 25.0002C24.974 22.699 26.8395 20.8335 29.1407 20.8335C31.4418 20.8335 33.3073 22.699 33.3073 25.0002C33.3073 27.3014 31.4418 29.1668 29.1407 29.1668C26.8395 29.1668 24.974 27.3014 24.974 25.0002Z",
    fill: "#1ABCFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 33.3332C16.6406 31.032 18.5061 29.1665 20.8073 29.1665H24.974V33.3332C24.974 35.6344 23.1085 37.4998 20.8073 37.4998C18.5061 37.4998 16.6406 35.6344 16.6406 33.3332Z",
    fill: "#0ACF83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.974 12.5V20.8333H29.1407C31.4419 20.8333 33.3073 18.9679 33.3073 16.6667C33.3073 14.3655 31.4419 12.5 29.1407 12.5H24.974Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 16.6667C16.6406 18.9679 18.5061 20.8333 20.8073 20.8333H24.974V12.5H20.8073C18.5061 12.5 16.6406 14.3655 16.6406 16.6667Z",
    fill: "#F24E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 25.0002C16.6406 27.3014 18.5061 29.1668 20.8073 29.1668H24.974V20.8335H20.8073C18.5061 20.8335 16.6406 22.699 16.6406 25.0002Z",
    fill: "#A259FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.30cbf50dd612c125b350c4e68cedab5b.svg";
export { ForwardRef as ReactComponent };